export enum ActiveSideView {
  Details = 'details',
  Tickets = 'tickets',
}
